const steps = [
  {
    disableBeacon: true,
    target: '.site-search-filter',
    title: 'Cerca',
    content: 'Scrivi una parola chiave per cercare tra i vari siti disponibili',
  },
  {
    target: '.show-brand-filter',
    title: 'Mostra brand',
    content: 'Organizza i siti suddivisi per brand',
  },
  {
    target: '.site-card',
    title: 'Sito',
    content: 'Clicca sul box per navigare al sito',
  }
];

export default steps;
